export default [
  {
    path: '/home',
    name: 'member.home',
    component: () => import(/* webpackChunkName: "member-home" */ '@/views/home/Home.vue')
  }
  // {
  // path: '/queue-request',
  // name: 'member.queue-request',
  // component: () => import(/* webpackChunkName: "member-home" */ '@/views/home/QueueRequest.vue')
  // }
]
